"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var defaults = {
  scrollableContainer: 'body',
  linkMarkup: '<div class="top-btn"></div>',
  displayOffsetTop: 400,
  showClass: 'show'
};

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var instance = {},
      settings = Object.assign({}, defaults, options),
      scrollableContainer = document.querySelector(settings.scrollableContainer),
      link,
      createLink = function createLink() {
    var tmp = document.createElement('div');
    tmp.innerHTML = settings.linkMarkup;
    return tmp.childNodes[0];
  },
      handleClick = function handleClick() {
    window.scrollTo(0, 0);
    scrollableContainer.scrollTo(0, 0);
  },
      handleScroll = function handleScroll(scrollPos) {
    if (scrollPos >= settings.displayOffsetTop) {
      link.classList.add(settings.showClass);
    } else {
      link.classList.remove(settings.showClass);
    }
  },
      bindEvents = function bindEvents() {
    link.addEventListener('click', handleClick);
    scrollableContainer.addEventListener('scroll', function () {
      handleScroll(scrollableContainer.scrollTop);
    });
    window.addEventListener('scroll', function () {
      handleScroll(window.scrollY || window.pageYOffset);
    });
  };

  if (!(scrollableContainer instanceof HTMLElement)) {
    throw new Error('Container element does not exist.');
  }

  link = document.body.appendChild(createLink());
  bindEvents();
  return instance;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/top-btn/index.js
// module id = 745
// module chunks = 0